import produce from 'immer';
import { FETCH_CONTENT_SCHEMA_SUCCEEDED, SET_HAS_BEEN_EDITED_IN_EDITOR, UPDATE_WEBVERSION_ENABLED, UPDATE_SETTINGS_SLUG_RAW } from 'ContentEditorUI/redux/actions/actionTypes';
import { withBaseContentModelAsJSObject } from 'ContentEditorUI/redux/reducers/contentModel/withBaseContentModel';
import emailPublishReducer from 'EmailEditorUI/redux/reducers/emailPublishReducer';
import emailSettingsReducer from 'EmailEditorUI/redux/reducers/emailContentModelSettingsReducer';
import rssSettingsReducer from 'EmailEditorUI/redux/reducers/rssSettingsReducer';
import { UPDATE_RECIPIENTS_DATA, UPDATE_AB_TEST_SETTINGS, UPDATE_JITTER_ENABLED, UPDATE_EMAIL_THROTTLE_SEND_SPEED, UPDATE_PREVIEW_TEXT_SPACING_ENABLED, UPDATE_CONTENT_MODEL_TRACKING_SETTINGS_VALUE } from 'EmailEditorUI/redux/actions/actionTypes';
import { CREATE_WEBVERSION_LINK } from 'EmailEditorUI/redux/actions/IframeSyncedActionTypes';
import mergeWith from 'hs-lodash/mergeWith';
const propertiesToCheck = ['vidsIncluded', 'vidsExcluded', 'mailingIlsListsIncluded', 'mailingIlsListsExcluded'];
export const emailContentModelReducer = (state = {}, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case FETCH_CONTENT_SCHEMA_SUCCEEDED:
        {
          const {
            content
          } = action.response;
          propertiesToCheck.forEach(key => {
            if (content[key]) {
              const cleanList = content[key].filter(v => !!v);
              if (cleanList.length < content[key].length) {
                content[key] = cleanList;
              }
            }
          });
          return Object.assign({}, draft, {
            abHoursToWait: content.abHoursToWait,
            abTestPercentage: content.abTestPercentage,
            abSuccessMetric: content.abSuccessMetric,
            abSampleSizeDefault: content.abSampleSizeDefault,
            abSamplingDefault: content.abSamplingDefault,
            blogEmailType: content.blogEmailType,
            businessUnitId: content.businessUnitId,
            canBeEditedInEmbeddedEditor: content.canBeEditedInEmbeddedEditor,
            disableAllTracking: content.disableAllTracking,
            emailType: content.emailType,
            vidsIncluded: content.vidsIncluded,
            vidsExcluded: content.vidsExcluded,
            mailingIlsListsIncluded: content.mailingIlsListsIncluded,
            mailingIlsListsExcluded: content.mailingIlsListsExcluded,
            isGraymailSuppressionEnabled: content.isGraymailSuppressionEnabled,
            isEngagementOptimizationEnabled: content.isEngagementOptimizationEnabled,
            contactQualityScoreSegment: content.contactQualityScoreSegment,
            contactQualityScoreThreshold: content.contactQualityScoreThreshold,
            htmlTitle: content.htmlTitle || content.subject,
            isRecipientFatigueSuppressionEnabled: content.isRecipientFatigueSuppressionEnabled,
            slug: content.slug,
            subscriptionBlogId: content.subscriptionBlogId,
            emailABStreamCampaignSendId: content.emailABStreamCampaignSendId,
            emailABStreamCampaignGroupId: content.emailABStreamCampaignGroupId,
            teamPerms: content.teamPerms,
            userPerms: content.userPerms,
            jitterEnabled: content.jitterEnabled,
            previewTextSpacingEnabled: content.previewTextSpacingEnabled,
            throttleSendSpeed: content.throttleSendSpeed,
            throttleSendSpeedOption: content.throttleSendSpeedOption
          });
        }
      case SET_HAS_BEEN_EDITED_IN_EDITOR:
        {
          draft.canBeEditedInEmbeddedEditor = false;
          return draft;
        }
      case UPDATE_AB_TEST_SETTINGS:
        {
          const {
            updatedProperties
          } = action;
          return mergeWith(draft, {
            abHoursToWait: updatedProperties.abHoursToWait,
            abTestPercentage: updatedProperties.abTestPercentage,
            abSuccessMetric: updatedProperties.abSuccessMetric,
            abSampleSizeDefault: updatedProperties.abSampleSizeDefault,
            abSamplingDefault: updatedProperties.abSamplingDefault
          }, (oldVal, newVal) => typeof newVal !== 'undefined' && newVal !== null ? newVal : oldVal);
        }
      case UPDATE_RECIPIENTS_DATA:
        {
          const {
            updatedProperties
          } = action;
          return mergeWith(draft, {
            vidsIncluded: updatedProperties.vidsIncluded,
            vidsExcluded: updatedProperties.vidsExcluded,
            mailingIlsListsIncluded: updatedProperties.mailingIlsListsIncluded,
            mailingIlsListsExcluded: updatedProperties.mailingIlsListsExcluded,
            isGraymailSuppressionEnabled: updatedProperties.isGraymailSuppressionEnabled,
            isRecipientFatigueSuppressionEnabled: updatedProperties.isRecipientFatigueSuppressionEnabled,
            isEngagementOptimizationEnabled: updatedProperties.isEngagementOptimizationEnabled,
            contactQualityScoreSegment: updatedProperties.contactQualityScoreSegment
          }, (oldVal, newVal) => typeof newVal !== 'undefined' && newVal !== null ? newVal : oldVal);
        }
      case UPDATE_WEBVERSION_ENABLED:
        {
          const {
            payload
          } = action;
          if (payload.createPage) {
            draft.htmlTitle = payload.subject;
            return draft;
          }
          return draft;
        }
      case CREATE_WEBVERSION_LINK:
        {
          const {
            subject
          } = action;
          if (!draft.htmlTitle) {
            draft.htmlTitle = subject;
          }
          return draft;
        }
      case UPDATE_SETTINGS_SLUG_RAW:
        {
          const {
            payload: {
              slugRaw
            }
          } = action;
          if (!slugRaw) {
            draft.linkSlugToTitle = true;
          }
          draft.slug = slugRaw;
          return draft;
        }
      case UPDATE_JITTER_ENABLED:
        {
          draft.jitterEnabled = action.payload.jitterEnabled;
          return draft;
        }
      case UPDATE_EMAIL_THROTTLE_SEND_SPEED:
        {
          const updatedProperties = action.payload;
          return mergeWith(draft, {
            throttleSendSpeedOption: updatedProperties.throttleSendSpeedOption,
            throttleSendSpeed: updatedProperties.throttleSendSpeed
          }, (oldVal, newVal) => typeof newVal !== 'undefined' && newVal !== null ? newVal : oldVal);
        }
      case UPDATE_PREVIEW_TEXT_SPACING_ENABLED:
        {
          draft.previewTextSpacingEnabled = action.payload.previewTextSpacingEnabled;
          return draft;
        }
      case UPDATE_CONTENT_MODEL_TRACKING_SETTINGS_VALUE:
        {
          draft.disableAllTracking = !action.payload.isTrackingEnabled;
          return draft;
        }
      default:
        return draft;
    }
  });
};
export default withBaseContentModelAsJSObject(emailPublishReducer, emailSettingsReducer, rssSettingsReducer, emailContentModelReducer);